import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_intercompany_auto_stock_processing_queue_RowInterface {
    guid :fromDatatype.GuidDataFieldInterface;
    src_generic_doc_guid:fromDatatype.GuidDataFieldInterface;
    src_generic_doc_type:fromDatatype.VarcharDatatypeInterface;
    src_generic_doc_server_doc_1:fromDatatype.VarcharDatatypeInterface;
    error_msg:fromDatatype.VarcharDatatypeInterface;
    process_status:fromDatatype.VarcharDatatypeInterface;
    namespace :fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}

export class bl_fi_intercompany_auto_stock_processing_queue_RowClass implements bl_fi_intercompany_auto_stock_processing_queue_RowInterface {
    guid :fromDatatype.GuidDataFieldInterface;
    src_generic_doc_guid:fromDatatype.GuidDataFieldInterface;
    src_generic_doc_type:fromDatatype.VarcharDatatypeInterface;
    src_generic_doc_server_doc_1:fromDatatype.VarcharDatatypeInterface;
    error_msg:fromDatatype.VarcharDatatypeInterface;
    process_status:fromDatatype.VarcharDatatypeInterface;
    namespace :fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}